"use strict";
var angular = require("angular");

var insertValueInstanceSeq = 0;

var textAreaInsertaValueCtrl = [
    "BuilderDataService",
    "$scope",
    "$timeout",
    "$translate",
    function (BuilderDataService, $scope, $timeout, $translate) {
        var _this = this;
        const form = BuilderDataService.getForm();
        this.objectID = "insertValue" + $scope.$id + "_" + (++insertValueInstanceSeq);
        this.value = this.value ?? "";
        this.valueElements = this.valueElements ?? [];
        this.father = this.father ?? [];
        this.showOptions = false;
        this.editorHTML = null;
        let editorRetries = 0;
        let destroyed = false;

        // Department
        this.departmentData = [
            { name: "Nombre Formulario", type: "text", id: "form_name" },
            { name: "Descripción Formulario", type: "text", id: "form_desc" },
            { name: "Fecha y Hora", type: "text", id: "form_date" },
            { name: "Creado", type: "text", id: "form_startedAt" },
            { name: "Cerrado", type: "text", id: "form_closedAt" },
            { name: "Subido", type: "text", id: "form_createdAt" },
            { name: "ID Formulario", type: "text", id: "form_id" },
            { name: "Nombre Usuario", type: "text", id: "member_firstName" },
            { name: "Apellido Usuario", type: "text", id: "member_lastName" },
            { name: "Email", type: "text", id: "member_email" },
        ]

        this.makeValue2HTML = () => {
            let arr = _this.value.match(/{{.*?}}/g);
            let valueHTML = _this.value;
            if (arr) {
                arr.forEach((fieldId) => {
                    let field = _this.valueElements.find(
                        (el) => `{{${el.id}}}` == fieldId
                    );
                    if (!field) {
                        return;
                    }
                    let newText = `<span name="field" hint="${field.id
                        }" value="${field.id
                        }" contenteditable="true" class="insertValueDirective_highlight">${field.name || field.label
                        }</span> `;
                    valueHTML = valueHTML.replace(fieldId, newText);
                });
            }
            return valueHTML;
        };

        const destructEditor = () => {
            if (_this.editorHTML) {
                try {
                    if (!_this.editorHTML.isDestructed) {
                        _this.editorHTML.destruct();
                    }
                } catch (e) {}
                _this.editorHTML = null;
            }
        };

        _this.loadEditorHTML = () => {
            if (destroyed) {
                return;
            }

            const el = document.getElementById(_this.objectID);
            if (!el) {
                if (editorRetries < 20) {
                    editorRetries++;
                    $timeout(_this.loadEditorHTML, 50);
                }
                return;
            }

            editorRetries = 0;
            destructEditor();

            _this.editorHTML = Jodit.make(el, {
                useSearch: false,
                iframe: false,
                enter: "BR",
                defaultMode: "1",
                disablePlugins:
                    "about,video,tooltip,speech-recognize,search,print,powered-by-jodit",
                placeholder: $translate.instant(
                    _this.placeholder
                ),
            });
        };

        this.toggleOptions = function () {
            this.showOptions = !this.showOptions;
        };

        this.insertOption = function (option) {
            let htmlContent = `&nbsp;<span name="field" value="${option.id
                }" contenteditable="true" class="insertValueDirective_highlight">${option.name || option.label
                }</span>&nbsp;`;

            if (_this.type === "jodit") {
                if (_this.editorHTML) {
                    _this.editorHTML.selection.insertHTML(htmlContent);
                }
            } else {
                let range = document.getElementById(_this.objectID).rangeATTR;
                if (range != undefined) {
                    range.deleteContents();
                    range.insertNode(
                        range.createContextualFragment(htmlContent)
                    );
                } else {
                    document.getElementById(_this.objectID).innerHTML =
                        htmlContent;
                }
                insertValueDirective_update(
                    document.getElementById(this.objectID)
                );
            }
            this.showOptions = false;
        };

        if (this.father == 'dept_report') {
            this.valueElements = JSON.parse(JSON.stringify(this.departmentData));
        }

        if (this.father == 'action_email' || this.father == 'form_report' || this.father == 'action_webservice') {
            this.valueElements = JSON.parse(JSON.stringify(this.departmentData)).concat(
                form.pages.reduce((lst, page) => {
                    lst = lst.concat(BuilderDataService.getListOfElements(page.fields, _this.excludeTypes));
                    return lst;
                }, [])
            );
        }

        // console.log('this.father', this.father)
        // console.log('this.valueElements', this.valueElements)

        $timeout(function () {
            if (_this.type === "jodit") {
                _this.loadEditorHTML();
            } else {
                const inputEl = document.getElementById(_this.objectID);
                if (inputEl) {
                    inputEl.innerHTML = _this.makeValue2HTML();
                }
            }
        }, 100);

        $scope.$on("$destroy", () => {
            destroyed = true;
            destructEditor();
        });
    },
];

module.exports = function () {
    return {
        restrict: "E",
        scope: {
            value: "=",
            element: "=",
            label: "=", // If label undefined for input type, label is not shown
            type: "=",
            placeholder: "=",
            excludeTypes: "=",
            required: "=", // If 'input' type and required === true.
            father: "=",
            emptyValue: "=?",
            emptyValueLabel: "@?",
            emptyValuePlaceholder: "@?",
            emptyValueTooltip: "@?",
        },
        controller: textAreaInsertaValueCtrl,
        controllerAs: "ctrl",
        bindToController: true,
        templateUrl: "directives/insertValueDirective.html",
        link: function (scope, element, attrs) {
            scope.ctrl.showEmptyValue = angular.isDefined(attrs.emptyValue);
        },
    };
};